import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'booking-number-cell',
    template: `<a
    matTooltip="View Booking"
    matTooltip-position="left"
    tooltipHideDelay="0"
    [routerLink]="['/bookings/view', id]"
  >
    {{ id }}
  </a>`,
    standalone: true,
    imports: [MatTooltip, RouterLink]
})
export class BookingNumberCellComponent implements AgRendererComponent {
  id;

  agInit(params: any): void {
    if (params.value) {
      this.id = params.value;
    }
  }

  refresh(params: any): boolean {
    this.id = params.value;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
